import { useEffect, useState } from "react";
import { useAuth } from "../../context/auth";
import { usePostponedBookings } from "../../services/bookingsService";
import { PostponedBookingDialog } from "../dialog/PostponedBookingDialog/PostponedBookingDialog";

export function PostponedBookingsManager() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [postponedBookings, setPostponedBookings] = useState([]);
    const { accessToken } = useAuth();

    const { data, isSuccess, refetch } = usePostponedBookings();

    useEffect(() => {
        const hasChecked = sessionStorage.getItem("postponedBookingsChecked");
        if (accessToken && !hasChecked) {
            sessionStorage.setItem("postponedBookingsChecked", "true");
            refetch();
        }
    }, [accessToken, refetch]);

    useEffect(() => {
        if (isSuccess && data && Array.isArray(data)) {
            setPostponedBookings(data);
        }
    }, [isSuccess, data]);

    const handleProcessed = () => {
        setCurrentIndex((prevIndex) => prevIndex + 1);
    };

    if (postponedBookings.length === 0 || currentIndex >= postponedBookings.length) {
        return null;
    }
    return (
        <PostponedBookingDialog
            booking={postponedBookings[currentIndex]}
            onProcessed={handleProcessed}
        />
    );
}
